import { useCallback } from "react";
import { useI18nContext, I18nMarkup } from "@hopper-b2b/i18n";
import {
  ActionButton,
  ActionLink,
  FloatingBox,
  IconComponent,
  IconName,
} from "@hopper-b2b/ui";
import { Box, Container, Typography } from "@material-ui/core";
import WrongAccountIcon from "../../assets/client/wrong-account.svg?react";
import { closeNubankWebview } from "../../utils/nubankHandoff";
import styles from "./AccessRestricted.module.scss";

export const AccessRestricted = () => {
  const { t } = useI18nContext();

  const handleClose = useCallback(() => {
    closeNubankWebview();
  }, []);

  return (
    <Container maxWidth="md" className={styles.fullHeight}>
      <Box className={styles.fullHeight}>
        <Box textAlign="start" px={3} py={2}>
          <ActionLink
            content={
              <IconComponent
                ariaLabel={t("closeModal")}
                name={IconName.Close}
                className={styles.closeIcon}
              />
            }
            onClick={handleClose}
          />
        </Box>
        <Box textAlign="start" px={3} py={1}>
          <WrongAccountIcon className={styles.errorIcon} />
        </Box>
        <Box textAlign="start" px={3} py={1.5}>
          <Typography className={styles.text} variant="h3" gutterBottom>
            {t("accessRestricted.title")}
          </Typography>
          <Typography className={styles.description}>
            <I18nMarkup tKey="accessRestricted.subtitle" />
          </Typography>
        </Box>
      </Box>
      <FloatingBox>
        <ActionButton
          message={t("accessRestricted.cta")}
          onClick={handleClose}
          className={styles.maintenanceButton}
        />
      </FloatingBox>
    </Container>
  );
};
